export default {
    state: {
        hasVFairs: false,
    },
    getters: {
        getHasVFairs: state => payload => state.hasVFairs,
    },
    mutations: {
        setHasVFairs: (state, bool) => {
            state.hasVFairs = bool;
        },
    },
};
